import { getFullUrl } from 'hubspot-url-utils';
import getLang from 'LearningCenterUI/utils/getLang';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error dependency missing types
import Chapter from 'academy-shared-js/records/Chapter';
// @ts-expect-error dependency missing types
import Video from 'academy-shared-js/records/Video';
// @ts-expect-error dependency missing types
import Quiz from 'academy-shared-js/records/Quiz';
// @ts-expect-error dependency missing types
import PracticalExercise from 'academy-shared-js/records/PracticalExercise';
// @ts-expect-error dependency missing types
import Link from 'academy-shared-js/records/Link';
// @ts-expect-error dependency missing types
import Exam from 'academy-shared-js/records/Exam';
import { DEFAULT_LANGUAGE } from '../constants/ApiConstants';
import { TrackingContentTypes } from '../constants/Tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_MINUTE_IN_SECONDS = 60;
export function getContentTypeForTracking(contentRecord) {
  if (contentRecord instanceof Video) {
    return TrackingContentTypes.VIDEO;
  } else if (contentRecord instanceof Quiz) {
    return TrackingContentTypes.QUIZ;
  } else if (contentRecord instanceof PracticalExercise) {
    return TrackingContentTypes.PRACTICAL_EXERCISE_FLOW;
  } else if (contentRecord instanceof Link) {
    return TrackingContentTypes.LINK;
  } else if (contentRecord instanceof Chapter) {
    return TrackingContentTypes.CHAPTER;
  }
  return 'unknown content type';
}
export function getContentNameByType(content, detailed = false) {
  if (!content) {
    return '';
  }
  if (content instanceof Quiz) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.quiz.quizYourself"
    });
  } else if (content instanceof PracticalExercise) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.practicalExercise.practicalExercise` + `${detailed ? `WithContentName` : ''}`,
      options: detailed ? {
        contentName: content.get('name')
      } : {}
    });
  }
  return content.get('name');
}

/**
 * This calculates the number of seconds that we should use to estimate how long an exam will take.
 * @param {number} questionCount - the number of questions in the exam
 * @returns {number} - the number of seconds in the computed duration of the exam
 */
export function calculateExamDurationSeconds(questionCount) {
  return questionCount * ONE_MINUTE_IN_SECONDS;
}
export function getDurationFromContent(thisContent) {
  if (thisContent instanceof Video) {
    return thisContent.get('duration');
  }
  if (thisContent instanceof Chapter) {
    return thisContent.get('readingTimeMinutes') * 60;
  }
  if (thisContent instanceof Exam) {
    return calculateExamDurationSeconds(thisContent.get('length'));
  }
  if (thisContent instanceof PracticalExercise) {
    return 3 * 60;
  } else if (thisContent instanceof Quiz) {
    return 3 * 60;
  } else if (thisContent instanceof Link) {
    return 5 * 60;
  }
  // all other types of content have undefined duration
  return undefined;
}
export function getDurationForContentList(contentList) {
  // all durations in seconds
  return contentList.reduce((seconds, thisContent) => {
    const time = getDurationFromContent(thisContent);
    return seconds + (time !== undefined ? time : 0);
  }, 0);
}
export function getProfessorDescription(professor, language = getLang()) {
  const description = professor.getIn(['descriptions', language.toLowerCase()]) || professor.getIn(['descriptions', DEFAULT_LANGUAGE]) || professor.get('descriptions').filter(descr => !!descr).first();
  return description;
}
export function getPracticalExerciseLink(practicalExercise, portalId, currentLocation) {
  const isUntracked = practicalExercise.get('trackerNotRequired');
  const rawLocation = practicalExercise.get('exerciseLocation');
  if (!rawLocation) {
    return null;
  }
  const link = `${getFullUrl('app')}/${rawLocation.replace('/l/', `/${portalId}/`)}`;
  if (isUntracked) {
    // special snowflake redirect (https://git.hubteam.com/HubSpot/LearningCenterUI/issues/1111)
    const maybeContainsRedirect = rawLocation.match(/academy\/l\/\?redirect=(.+)/);
    if (maybeContainsRedirect) {
      const redirectUrl = maybeContainsRedirect[1];
      // sanity check of the domain
      if (/^http(s?):\/\/([a-z]*).hubspot((qa)?).com/.test(redirectUrl)) {
        return redirectUrl;
      }
    }
    return link;
  }
  return `${link}?academy=true&academyRedirectUrl=${encodeURIComponent(currentLocation)}`;
}
export function getFormattedExerciseLocation(rawLocation, portalId) {
  const link = `${getFullUrl('app')}/${rawLocation.replace('/l/', `/${portalId}/`)}`;

  // special snowflake redirect (https://git.hubteam.com/HubSpot/LearningCenterUI/issues/1111)
  const maybeContainsRedirect = rawLocation.match(/academy\/l\/\?redirect=(.+)/);
  if (maybeContainsRedirect) {
    const redirectUrl = maybeContainsRedirect[1];
    // sanity check of the domain
    if (/^http(s?):\/\/([a-z]*).hubspot((qa)?).com/.test(redirectUrl)) {
      return redirectUrl;
    }
  }
  return link;
}